import React, { useEffect } from "react";
import { times } from "lodash";
import { useTheme } from "@mui/material/styles";

import { useMap } from "react-map-gl";

import { extractBreaks, getFillColor } from "@/utils";
import { LocationResult } from "@/types";

type PenPortraitMapOverlayProps = {
  scores: LocationResult;
  firstTime: boolean;
};

export const PenPortraitMapOverlay: React.FC<PenPortraitMapOverlayProps> = ({
  scores,
  firstTime,
}) => {
  const { current: map } = useMap();
  const theme = useTheme();

  useEffect(() => {
    if (!firstTime) {
      map && map.isStyleLoaded() && resetMap();
      map &&
        scores.area.forEach((value) => {
          map.setFeatureState(
            {
              id: value.gid,
              source: "area-source",
              sourceLayer: "postal_area_test",
            },
            { score: value.rate, name: value.name, level: value.level },
          );
        });
      map &&
        map
          .getMap()
          .setPaintProperty(
            "area-base",
            "fill-color",
            getFillColor(extractBreaks(scores.area), theme.palette.gradient),
          );
    }
  }, [firstTime, map, scores]);

  const resetMap = () => {
    map &&
      [...times(124)].forEach((value) => {
        map.setFeatureState(
          { id: value, source: "area-source", sourceLayer: "postal_area_test" },
          { score: null, name: null, level: null },
        );
      });
  };

  return <></>;
};
